import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { URLS } from './constants/constants';
import { AuthService } from '../common/services/auth.service';
import { LaunchToolDto } from './launch-tool/dtos/launch-tool.dto';


@Injectable({
  providedIn: 'root'
})
export class PlatformService {
   constructor(private httpClient:HttpClient, private authService:AuthService){}
   initiateCourseLibraryLaunch(courseCode:string,userData:LaunchToolDto){
    this.httpClient.post(`${URLS.OIDC_INITIATE_API}`,{
      courseCode,
      userId:userData.email,
      userInfo:{
        email:userData.email,
        given_name:userData.firstName,
        family_name:userData.lastName
      },
      requestId: `request-${new Date().getTime()}`,
      isCourseLaunch:false,
      targetLinkURI:userData.targetLinkURI
    },{
      headers:this.authService.getAuthHeaders()
    }).subscribe(data=>{
       this.submitFormToTool(data);
    });
  }
  initiateCourseLaunch(courseCode:string,userData:LaunchToolDto, openInNewWindow = false){
    this.httpClient.post(`${URLS.OIDC_INITIATE_API}`,{
      courseCode,
      userId:userData.userId,
      userInfo:{
        email:userData.email,
        given_name:userData.firstName,
        family_name:userData.lastName
      },
      requestId: `request-${new Date().getTime()}`,
      isCourseLaunch: true,
      custom:userData.custom,
      targetLinkURI:userData.targetLinkURI
    }).subscribe(data=>{
       this.submitFormToTool(data, openInNewWindow);
    });
  }
  private submitFormToTool(data: any, openInNewWindow = false): void {
    const form = document.createElement('form');
    form.method =  'POST';
    form.action =  data.action;
    if (openInNewWindow) {
      form.target = '_blank';
    }
    delete data.action;
    Object.entries(data).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = typeof value === 'string' ? value : JSON.stringify(value);
      form.appendChild(input);
    });
    document.body.appendChild(form);
    //console.log("submitFormToTool", form)
    form.submit();
  }
}
